import React from 'react'
import PropTypes from 'prop-types'

const UnderlineEffect = ({ children }) => (
  <span className='w-fit bg-left-bottom bg-gradient-to-r from-brand-primary to-brand-primary bg-[length:0%_2px] bg-no-repeat hover:bg-[length:100%_2px] transition-all duration-500 ease-out'>
    {children}
  </span>
)

UnderlineEffect.propTypes = {
  children: PropTypes.node
}

export default UnderlineEffect
